import { render } from "./LMSAdmin.vue?vue&type=template&id=371a0dbc&scoped=true"
import script from "./LMSAdmin.vue?vue&type=script&lang=js"
export * from "./LMSAdmin.vue?vue&type=script&lang=js"

import "./LMSAdmin.vue?vue&type=style&index=0&id=371a0dbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371a0dbc"]])

export default __exports__